import React, {Fragment, useState} from 'react';
import {Modal, message, Radio} from 'antd';
import {recordProxy} from '../../util';
import iconRightSvg from './imgs/icon-right.svg';

const Message = message;
interface Props {
    anchor: any;
    channelId: any;
    authMethodOptShow: any;
    setAuthMethodOptShow: Function;
    formData: any;
    onReset: Function;
    fetchDelegationType: Function;
    openModal: Function;
}
export default function AuthMethodOptModal(props: Props) {
    const {anchor, channelId, formData, fetchDelegationType, onReset, openModal} = props;
    const {authMethodOptShow, setAuthMethodOptShow} = props;

    const [attestType, setAttestType] = useState('0');

    // const [authMethodOptShow, setAuthMethodOptShow] = useState(props.authMethodOptShow);
    // useEffect(()=>{
    //     setAuthMethodOptShow(props.authMethodOptShow);
    // }, [props.authMethodOptShow]);
    const attestMethodCb = () => {
        const postData = {
            ...formData,
            sub_type: Number(attestType),
            source: channelId || '',
        };
        fetchDelegationType(postData).then(data => {
            if (data.code === 200) {
                onReset();
                // recordProxy('newPreAttest', 'click', 'onOk');
                recordProxy(
                    anchor ? 'newPreAttest-submit' : 'newPreAttest',
                    'click',
                    JSON.stringify({tag: 'onOk'})
                );

                if (attestType === '1') {
                    recordProxy('newPreAttest', 'click', 'independent');
                } else {
                    recordProxy('newPreAttest', 'click', 'assisted');
                }
                attestMethodCbNext();
                setAuthMethodOptShow(false);
            } else {
                setAuthMethodOptShow(false);
                Message.error({
                    content: data.message,
                    delay: 3000
                });
            }
        });
    };
    const attestMethodCbNext = () => {
        const {attestType} = this.state;
        if (attestType === '0') {
            openModal('info', {
                title: '信息提交成功',
                okText: '知道了',
                content: (<div className="page-attest-modal-content">
                    <img src={iconRightSvg} className="success-logo"></img>
                    <div className="modal-info">
                        <p className="title">您的信息已提交，百度官方合作伙伴将在1个工作日内向您致电。</p>
                        <p className="info-tip">如有其他问题，可发送邮件到haomakefu@baidu.com。</p>
                    </div>
                </div>),
            });
        } else {
            openModal('info', {
                title: '信息提交成功',
                okText: '知道了',
                content: (<div className="page-attest-modal-content">
                    <img src={iconRightSvg} className="success-logo"></img>
                    <div className="modal-info">
                        <p className="title">您的信息已提交，官方客服将在7天内向您致电。</p>
                        <p className="info-tip">如有其他问题，可发送邮件到haomakefu@baidu.com。</p>
                    </div>
                </div>),
            });
        }
    };
    return (
        <Fragment>
            <Modal
                title="请选择您的认证方式"
                cancelText="取消"
                okText="确定提交"
                className="page-attest-auth-method-modal"
                width={600}
                centered
                visible={authMethodOptShow}
                closable={false}
                onOk={attestMethodCb}
                onCancel={() => {
                    recordProxy('attest', 'click', 'authMethod-confirm-cancel');
                    setAuthMethodOptShow(false);
                }}
            >
                <div className={'attest-method-content'}>
                    <div
                        className={'attest-method-item' + (attestType === '0' ? ' on' : '')}
                        onClick={() => this.setState({attestType: '0'})}
                    >
                        <Radio
                            name="attestType"
                            className="attestType-radio"
                            // theme={'blue'}
                            checked={attestType === '0'}
                        >
                            百度官方合作伙伴协助认证
                        </Radio>
                        <div className={'radio-text'}>
                            <p>1.合作伙伴提供<span>专属答疑及售后服务</span></p>
                            <p>2.产品<span>价格有优惠</span></p>
                            <p>3.认证<span>流程更简洁</span></p>
                            <p>4.审核<span>通过率更高</span></p>
                        </div>
                        <img className={'radio-icon'}
                            width={70}
                            src={require('../../asset/img/attest/recommend.png')}></img>
                    </div>
                    <div
                        className={'attest-method-item' + (attestType === '1' ? ' on' : '')}
                        onClick={() => setAttestType('1')}
                    >
                        <Radio
                            name="attestType"
                            className="attestType-radio"
                            checked={attestType === '1'}
                        >
                            百度官网自主认证
                        </Radio>
                        <div className={'radio-text'}>
                            <p>1.无专属答疑及售后服务</p>
                            <p>2.产品价格无优惠</p>
                            <p>3.认证流程更复杂</p>
                            <p>4.审核通过率正常</p>
                        </div>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
}
